import { Box, Button } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import Flex from "../../../../../../../../components/Flex";
import Text from "../../../../../../../../components/Text";

interface EligibilityOverviewStatusProps {
  title: string;
  description: string;
  redirectToViewReport: boolean;
  onViewReport?: () => void;
  onClose?: () => void;
}

const EligibilityOverviewStatus = ({
  title,
  description,
  redirectToViewReport,
  onViewReport,
  onClose,
}: EligibilityOverviewStatusProps) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          bgcolor: "white",
          borderRadius: 2,
          p: 3,
          maxWidth: "500px",
          width: "90%",
          position: "relative",
          boxShadow: 3,
        }}
      >
        {/* Header */}
        <Flex justifyContent="space-between" alignItems="center" mb={3}>
          <Text fontSize="20px" fontWeight={600} color="#333">
            {title}
          </Text>
          <Flex gap={1}>
            <Box
              component="span"
              sx={{ cursor: "pointer", p: 1 }}
              onClick={onClose}
            >
              ✕
            </Box>
          </Flex>
        </Flex>

        {/* Content */}
        <Flex flexDirection="column" alignItems="center" gap={3}>
          {/* Success Icon */}
          <Box
            sx={{
              bgcolor: "#E8F5E8",
              borderRadius: "50%",
              width: "80px",
              height: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CheckCircle sx={{ fontSize: 48, color: "#4CAF50" }} />
          </Box>

          {/* Primary Message */}
          <Text
            fontSize="18px"
            fontWeight={500}
            color="#333"
            textAlign="center"
          >
            Eligibility check completed successfully.
          </Text>

          {/* Detailed Message Box */}
          <Box
            sx={{
              bgcolor: "#F0F9F0",
              border: "1px solid #D4EDDA",
              borderRadius: 1,
              p: 2,
              width: "100%",
            }}
          >
            <Text fontSize="14px" color="#155724" textAlign="center">
              {description}
            </Text>
          </Box>

          {/* Action Button */}
          {redirectToViewReport && (
            <Button
              component="button"
              onClick={() => onViewReport?.()}
              sx={{
                bgcolor: "white",
                border: "1px solid #1976D2",
                color: "#1976D2",
                borderRadius: 1,
                px: 3,
                py: 1.5,
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
                "&:hover": {
                  bgcolor: "#F5F5F5",
                },
              }}
            >
              View Report
            </Button>
          )}
        </Flex>
      </Box>
    </Box>
  );
};

export default EligibilityOverviewStatus;
